module.exports = __webpack_public_path__ + "img/abstract-shapes-9.27b7950a.svg";